module.exports = __webpack_public_path__ + "img/icon19.aab6deed.png";